import { useSelector } from 'react-redux';
import { CustomerCardState } from '@makemydeal/dr-sales-checkin-types';
import type { CommonState } from './types/common';
import type { SalesCheckinRootState } from './types/SalesCheckinRootState';

const getCommon = (state: SalesCheckinRootState): CommonState => state.salesCheckin.common || ({} as CommonState);

export const getSalesCheckInMode = (state: SalesCheckinRootState): string => getCommon(state).salesCheckInMode || '';

export const isCustomerCardOpen = (state: SalesCheckinRootState): boolean => {
    const customerCardState = getCommon(state).customerCardState;
    return !!customerCardState && customerCardState !== CustomerCardState.CLOSE;
};

export const useCommonSelector = (): CommonState => useSelector(getCommon);

export const getCustomerVehiclesDealsCount = (state: SalesCheckinRootState): number =>
    (state as unknown as { customerVehicles?: { dealsCount?: number } }).customerVehicles?.dealsCount ?? 0;
